export default defineComponent({
  name: 'EquivalenceItem',
  props: {
    titleLeft: String,
    textLeft: String,
    textRight: String,
    image: Object,
    noBorder: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    }
  }
});